import { Engine as BabylonEngine } from '@babylonjs/core/Engines/engine';
import { Scene } from '@babylonjs/core/scene';
import { installAdaptiveQuality } from './AdaptiveQuality';
import { installMobileDiagnostics } from './MobileDiagnostics';
import { getRuntimeProfile, installViewportSizing } from './RuntimeProfile';

let engine: BabylonEngine;
let scene: Scene;

export function initEngine(canvas: HTMLCanvasElement): { engine: BabylonEngine; scene: Scene } {
  const profile = getRuntimeProfile();
  installViewportSizing();

  engine = new BabylonEngine(canvas, profile.antialias, {
    preserveDrawingBuffer: profile.preserveDrawingBuffer,
    stencil: profile.stencil,
    antialias: profile.antialias,
    powerPreference: profile.isMobile ? 'default' : 'high-performance',
  });
  engine.setHardwareScalingLevel(1 / profile.pixelRatio);

  scene = new Scene(engine);
  scene.clearColor.set(0, 0, 0, 1);
  scene.useRightHandedSystem = false;
  scene.collisionsEnabled = false;

  const resize = () => engine.resize();
  window.addEventListener('resize', resize, { passive: true });
  window.visualViewport?.addEventListener('resize', resize, { passive: true });
  const adaptive = installAdaptiveQuality(engine, profile);
  installMobileDiagnostics(engine, canvas, profile, adaptive);

  // Expose for performance monitoring
  if (typeof window !== 'undefined') {
    (window as any).__babylonEngine = engine;
    (window as any).__babylonScene = scene;
  }

  return { engine, scene };
}

export function getEngine(): BabylonEngine {
  return engine;
}

export function getScene(): Scene {
  return scene;
}
